module.exports = __webpack_public_path__ + "static/media/footer-pattern.806b2d14.svg";